/* 🤖 this file was generated by svg-to-ts */
export const matIconLineWeight: {
  name: 'line-weight';
  data: string;
} = {
  name: 'line-weight',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"/></svg>`
};
